import { useState } from 'react';
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, DialogContentText, Typography, makeStyles } from '@material-ui/core';
import { useUpsertUserCompanies } from 'client/hooks/user/useUpsertUserCompanies';
import { useListCompanies } from 'common/hooks/company/useListCompanies';

const styles = {
    btnCancel: {
        border: '1px solid #2b333f',
        color: '#2b333f',
        '&:active': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:hover': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:disabled': {
            backgroundColor: '#eee !important',
            color: '#ccc !important',
        },
    },
    btnCOnfirm: {
        marginLeft: '5px',
    },
};

const useStyles = makeStyles(styles);

interface ICompanyAssignmentDialog {
    open: boolean;
    userId: string;
    userCompanyIds: number[];
    close: () => void;
}

export const CompanyAssignmentDialog = ({ open, userId, userCompanyIds, close }: ICompanyAssignmentDialog) => {
    const classes = useStyles();
    const { isLoading, companies } = useListCompanies();
    const [newCompanyIds, setNewCompanyIds] = useState<number[]>(userCompanyIds);
    const { updateUserCompanies } = useUpsertUserCompanies();
    const [isProgress, setProgress] = useState(false);

    const handleCompanyChange = (id: number) => {
        if (newCompanyIds.includes(id)) {
            setNewCompanyIds(newCompanyIds.filter(companyId => companyId !== id));
        } else {
            setNewCompanyIds([...newCompanyIds, id]);
        }
    };

    const handelConfirm = async () => {
        setProgress(true);

        try {
            await updateUserCompanies({
                userId: userId,
                companyIds: newCompanyIds,
            });

            close();
        } catch (error) {
            console.error('Error updating user companies:', error);
        }

        setProgress(false);
    };

    return (
        <>
            <Dialog open={open} aria-labelledby="form-dialog-title">
                <DialogContent>
                    <DialogContentText color="primary">
                        <Box p={2} style={{ width: '25vw' }}>
                            <Typography variant="h6">Companies Assigment</Typography>
                            <Typography>Please select companies to assign. Click confirm to save changes.</Typography>
                            <Box p={1}></Box>
                            {isLoading && <CircularProgress size={25} thickness={8} color="primary" />}
                            {!isLoading &&
                                companies &&
                                companies.map(company => (
                                    <Box key={company.id} display="flex" alignItems="center">
                                        <Checkbox
                                            id={`${company.id}-checkbox`}
                                            name={`${company.id}-checkbox`}
                                            color="primary"
                                            required={false}
                                            checked={newCompanyIds.includes(company.id)}
                                            onChange={() => handleCompanyChange(company.id)}
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                        <Typography variant="body1">{company.name}</Typography>
                                    </Box>
                                ))}
                            <Box p={1}></Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', p: 1, m: 1, justifyContent: 'flex-start' }}>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    color="secondary"
                                    onClick={close}
                                    disabled={isProgress}
                                    className={classes.btnCancel}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    autoFocus
                                    variant="contained"
                                    size="medium"
                                    onClick={handelConfirm}
                                    disabled={isProgress}
                                    className={classes.btnCOnfirm}
                                >
                                    Confirm
                                    <Box sx={{ ml: 1, mr: 1 }}>{isProgress ? <CircularProgress size={'0.8rem'} color="inherit" /> : <></>}</Box>
                                </Button>
                            </Box>
                            <Box p={2}></Box>
                        </Box>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </>
    );
};
